import Vue from 'vue';
import Vuex from 'vuex';
import {
	mapState, mapGetters, mapMutations, mapActions
} from 'vuex';

import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

let state = {
	//Used for stackable modals
	modals: [],
	showNavMenu: true,
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters
});

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
